import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Autocomplete,
  IconButton,
  InputAdornment,
  Tooltip,
  Icon,
} from "@mui/material";

import AttachFileIcon from "@mui/icons-material/AttachFile";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

import { createAutocompleteFilter } from "pages/utils/autocompleteFilter";

export default function DialogFichaTransporteForm({
  open,
  onClose,
  editando,
  children,
  actions,

  form,
  setForm,
  podeEditarCamposBase,
  matriculas,
  pessoasMotorista,
  pessoasAjudante,
  nullIfEmpty,
  normTri,
  formatRefTransporteOnBlur,
  formatMatriculaOnBlur,
  matriculaCleanLength,
  prefillSemFicha,
  setPrefillSemFicha,
  carregarUltimaEquipaPorMatricula,
  verificarFichaTransportePorRef,
  refTransporteDuplicada,
  idFichaExistente,
  estadoFichaExistente,
  showAlert,

  suporteVoz,
  campoVozAtivo,
  setCampoVozAtivo,
  botaoVozDesativado,

  reconhecendoVozConfMapaCargaDesc,
  pararVozConfMapaCargaDesc,
  iniciarVozConfMapaCargaDesc,

  reconhecendoVozDifMercadoriaDesc,
  pararVozDifMercadoriaDesc,
  iniciarVozDifMercadoriaDesc,

  reconhecendoVozQuebrasDanificadoDesc,
  pararVozQuebrasDanificadoDesc,
  iniciarVozQuebrasDanificadoDesc,

  reconhecendoVozDifVasilhameDesc,
  pararVozDifVasilhameDesc,
  iniciarVozDifVasilhameDesc,

  reconhecendoVozObservacoes,
  pararVozObservacoes,
  iniciarVozObservacoes,

  temId,
  podeEditarAux,
  temPendentesOcorrencias,
  handleEncerrar,
  handleSave,
  abrirFichaExistente,
  setOpenFicheiros,
  aplicarDefaultsPessoas,
}) {
  const [refTransporteInput, setRefTransporteInput] = useState(form.reftransporte || "");
  const [matriculaInput, setMatriculaInput] = useState(form.matricula || "");
  const [observacoesInput, setObservacoesInput] = useState(form.observacoes || "");
  const [confMapaCargaDescInput, setConfMapaCargaDescInput] = useState(
    form.conf_mapa_carga_desc || ""
  );
  const [difMercadoriaDescInput, setDifMercadoriaDescInput] = useState(
    form.dif_mercadoria_desc || ""
  );
  const [quebrasDanificadoDescInput, setQuebrasDanificadoDescInput] = useState(
    form.quebras_danificado_desc || ""
  );
  const [difVasilhameDescInput, setDifVasilhameDescInput] = useState(form.dif_vasilhame_desc || "");

  const bloquearCamposBase = !podeEditarCamposBase || refTransporteDuplicada;

  useEffect(() => {
    if (open) {
      setRefTransporteInput(form.reftransporte || "");
      setMatriculaInput(form.matricula || "");
      setObservacoesInput(form.observacoes || "");
      setConfMapaCargaDescInput(form.conf_mapa_carga_desc || "");
      setDifMercadoriaDescInput(form.dif_mercadoria_desc || "");
      setQuebrasDanificadoDescInput(form.quebras_danificado_desc || "");
      setDifVasilhameDescInput(form.dif_vasilhame_desc || "");
    }
  }, [
    open,
    form.id,
    form.reftransporte,
    form.matricula,
    form.observacoes,
    form.conf_mapa_carga_desc,
    form.dif_mercadoria_desc,
    form.quebras_danificado_desc,
    form.dif_vasilhame_desc,
  ]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        {editando ? "Editar Ficha de Transporte" : "Nova Ficha de Transporte"}
      </DialogTitle>

      <DialogContent dividers>
        <MDBox display="flex" gap={2} flexWrap="wrap" alignItems="flex-end">
          <MDBox sx={{ minWidth: 170 }}>
            <MDTypography variant="button" sx={{ fontSize: 12, mb: 0.5 }}>
              Data da Ficha
            </MDTypography>
            <TextField
              type="date"
              size="small"
              value={form.dataficha}
              onChange={(e) => setForm((s) => ({ ...s, dataficha: e.target.value }))}
              disabled={bloquearCamposBase}
              fullWidth
              sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2, fontSize: 13 } }}
            />
          </MDBox>

          <MDBox sx={{ minWidth: 220 }}>
            <MDTypography variant="button" sx={{ fontSize: 12, mb: 0.5 }}>
              Ref. Transporte *
            </MDTypography>
            <TextField
              size="small"
              value={refTransporteInput}
              onChange={(e) => {
                setPrefillSemFicha(false);
                setRefTransporteInput(e.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  e.target.blur();
                }
              }}
              onBlur={async () => {
                const refFormatada = formatRefTransporteOnBlur(refTransporteInput);

                setRefTransporteInput(refFormatada);

                setForm((s) => ({
                  ...s,
                  reftransporte: refFormatada,
                }));

                if (!refFormatada) return;
                if (prefillSemFicha) return;

                const validacao = await verificarFichaTransportePorRef(refFormatada, form.id);

                if (validacao == null) return;

                if (validacao?.existe) {
                  showAlert(
                    `Já existe uma ficha anterior para a ref. transporte ${refFormatada} (ID ${validacao.id}).`,
                    "warning"
                  );
                  return;
                }

                if (refFormatada || form.matricula) {
                  await carregarUltimaEquipaPorMatricula(form.matricula, refFormatada);
                }
              }}
              disabled={bloquearCamposBase}
              fullWidth
              sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2, fontSize: 13 } }}
            />
          </MDBox>

          <MDBox sx={{ minWidth: 220 }}>
            <MDTypography variant="button" sx={{ fontSize: 12, mb: 0.5 }}>
              Matrícula
            </MDTypography>
            <Autocomplete
              freeSolo
              size="small"
              options={matriculas || []}
              filterOptions={createAutocompleteFilter((opt) => opt || "")}
              value={nullIfEmpty(matriculaInput) || null}
              inputValue={matriculaInput || ""}
              disabled={bloquearCamposBase}
              onInputChange={(_, v, reason) => {
                if (reason === "input" || reason === "clear") {
                  setPrefillSemFicha(false);
                  setMatriculaInput((v || "").toUpperCase());
                }
              }}
              onChange={async (_, v) => {
                const val = formatMatriculaOnBlur(v || "");

                setPrefillSemFicha(false);
                setMatriculaInput(val);

                setForm((s) => ({
                  ...s,
                  matricula: val,
                }));

                if (val) {
                  await carregarUltimaEquipaPorMatricula(val, null);
                }
              }}
              getOptionLabel={(opt) => opt || ""}
              isOptionEqualToValue={(opt, val) => String(opt) === String(val)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Selecionar matrícula"
                  onBlur={async () => {
                    const val = matriculaInput;
                    const len = matriculaCleanLength(val);

                    if (len > 0 && len < 6) {
                      showAlert(
                        "A matrícula tem de ter pelo menos 6 caracteres (sem contar hífens).",
                        "error"
                      );
                      return;
                    }

                    const matriculaFormatada = formatMatriculaOnBlur(val);

                    setMatriculaInput(matriculaFormatada);

                    setForm((s) => ({
                      ...s,
                      matricula: matriculaFormatada,
                    }));

                    if (prefillSemFicha) return;

                    if (matriculaFormatada) {
                      await carregarUltimaEquipaPorMatricula(matriculaFormatada, null);
                    }
                  }}
                  sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2, fontSize: 13 } }}
                />
              )}
            />
          </MDBox>

          <MDBox sx={{ minWidth: 260 }}>
            <MDTypography variant="button" sx={{ fontSize: 12, mb: 0.5 }}>
              Distribuidor 1
            </MDTypography>
            <Autocomplete
              freeSolo
              size="small"
              options={pessoasMotorista}
              filterOptions={createAutocompleteFilter((opt) => opt || "")}
              value={nullIfEmpty(form.motorista) || null}
              disabled={bloquearCamposBase}
              onChange={(_, v) => {
                const val = v || "";
                setForm((s) =>
                  aplicarDefaultsPessoas(
                    {
                      ...s,
                      motorista: val,
                      auxilio_mot_arm1: val ? s.auxilio_mot_arm1 : 2,
                      auxilio_mot_arm2: val ? s.auxilio_mot_arm2 : 2,
                    },
                    val,
                    s.ajudante,
                    true
                  )
                );
              }}
              getOptionLabel={(opt) => opt || ""}
              isOptionEqualToValue={(opt, val) => String(opt) === String(val)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="(nenhum)"
                  sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2, fontSize: 13 } }}
                />
              )}
            />
          </MDBox>

          <MDBox sx={{ minWidth: 260 }}>
            <MDTypography variant="button" sx={{ fontSize: 12, mb: 0.5 }}>
              Distribuidor 2
            </MDTypography>
            <Autocomplete
              freeSolo
              size="small"
              options={pessoasAjudante}
              filterOptions={createAutocompleteFilter((opt) => opt || "")}
              value={nullIfEmpty(form.ajudante) || null}
              disabled={bloquearCamposBase}
              onChange={(_, v) => {
                const val = v || "";
                setForm((s) =>
                  aplicarDefaultsPessoas(
                    {
                      ...s,
                      ajudante: val,
                      auxilio_ajud_arm1: val ? s.auxilio_ajud_arm1 : 2,
                      auxilio_ajud_arm2: val ? s.auxilio_ajud_arm2 : 2,
                    },
                    s.motorista,
                    val,
                    true
                  )
                );
              }}
              getOptionLabel={(opt) => opt || ""}
              isOptionEqualToValue={(opt, val) => String(opt) === String(val)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="(nenhum)"
                  sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2, fontSize: 13 } }}
                />
              )}
            />
          </MDBox>
        </MDBox>

        {refTransporteDuplicada && idFichaExistente > 0 && (
          <MDBox mt={2}>
            <MDBox
              sx={{
                border: "1px solid rgba(255, 152, 0, 0.35)",
                backgroundColor: "rgba(255, 152, 0, 0.08)",
                borderRadius: 2,
                p: 1.5,
              }}
            >
              <MDTypography variant="button" sx={{ fontSize: 12, color: "warning.main" }}>
                Já existe uma ficha anterior para esta referência.
              </MDTypography>

              <MDBox mt={1} display="flex" alignItems="center" gap={1} flexWrap="wrap">
                <MDTypography variant="button" sx={{ fontSize: 12 }}>
                  ID da ficha existente: <strong>{idFichaExistente}</strong>
                </MDTypography>

                {Number(estadoFichaExistente) === 1 ? (
                  <MDTypography variant="button" sx={{ fontSize: 12, color: "error.main" }}>
                    A ficha existente está encerrada e não pode ser aberta para edição.
                  </MDTypography>
                ) : (
                  <MDButton
                    color="warning"
                    size="small"
                    onClick={() => {
                      abrirFichaExistente(idFichaExistente);
                    }}
                  >
                    Abrir ficha existente
                  </MDButton>
                )}
              </MDBox>
            </MDBox>
          </MDBox>
        )}

        <MDBox sx={{ minWidth: 240 }}>
          <MDTypography variant="button" sx={{ fontSize: 12, mb: 0.5 }}>
            Mapa de Carga *
          </MDTypography>

          <select
            value={normTri(form.conf_mapa_carga)}
            onChange={(e) => {
              const novoValor = normTri(e.target.value);

              if (novoValor !== 2 && reconhecendoVozConfMapaCargaDesc) {
                pararVozConfMapaCargaDesc();
                setCampoVozAtivo("");
              }

              if (novoValor !== 2) {
                setConfMapaCargaDescInput("");
              }

              setForm((s) => ({
                ...s,
                conf_mapa_carga: novoValor,
                conf_mapa_carga_desc: novoValor === 2 ? confMapaCargaDescInput : "",
              }));
            }}
            disabled={bloquearCamposBase}
            style={{
              width: "100%",
              padding: "10px 12px",
              borderRadius: 8,
              border: "1px solid rgba(0,0,0,0.23)",
              fontSize: 13,
              background: "white",
            }}
          >
            <option value={0}>PENDENTE</option>
            <option value={1}>CORRETA</option>
            <option value={2}>INCORRETA</option>
          </select>

          {normTri(form.conf_mapa_carga) === 2 && (
            <TextField
              size="small"
              multiline
              minRows={5}
              maxRows={10}
              value={confMapaCargaDescInput}
              onChange={(e) => setConfMapaCargaDescInput(e.target.value)}
              onBlur={() =>
                setForm((s) => ({
                  ...s,
                  conf_mapa_carga_desc: confMapaCargaDescInput,
                }))
              }
              disabled={!podeEditarCamposBase}
              fullWidth
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Tooltip
                      title={
                        !suporteVoz
                          ? "Ditado não suportado neste browser"
                          : reconhecendoVozConfMapaCargaDesc
                          ? "A gravar… clique para parar"
                          : campoVozAtivo
                          ? "Já existe outra gravação em curso"
                          : "Ditado por voz (Chrome). Use a palavra 'ponto' para terminar a frase e mudar de linha."
                      }
                    >
                      <span>
                        <IconButton
                          edge="end"
                          size="small"
                          onClick={() => {
                            if (reconhecendoVozConfMapaCargaDesc) {
                              pararVozConfMapaCargaDesc();
                              setCampoVozAtivo("");

                              setForm((s) => ({
                                ...s,
                                conf_mapa_carga_desc: confMapaCargaDescInput,
                              }));
                            } else {
                              iniciarVozConfMapaCargaDesc();
                              setCampoVozAtivo("conf_mapa_carga_desc");
                            }
                          }}
                          disabled={botaoVozDesativado("conf_mapa_carga_desc")}
                          sx={{
                            color: reconhecendoVozConfMapaCargaDesc
                              ? "error.main"
                              : "action.active",
                          }}
                        >
                          <Icon fontSize="small">
                            {reconhecendoVozConfMapaCargaDesc ? "mic_off" : "mic"}
                          </Icon>
                        </IconButton>
                      </span>
                    </Tooltip>
                  </InputAdornment>
                ),
              }}
              sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2, fontSize: 13 } }}
            />
          )}

          {temId ? (
            <MDBox sx={{ flex: 1, width: "100%", minWidth: 0 }}>
              <MDTypography
                variant="button"
                sx={{
                  fontSize: 13,
                  mb: 0.5,
                  fontWeight: 700,
                  color: "info.main",
                }}
              >
                Observações durante as entregas
              </MDTypography>
              <TextField
                size="small"
                multiline
                minRows={5}
                maxRows={10}
                value={observacoesInput}
                onChange={(e) => setObservacoesInput(e.target.value)}
                onBlur={() =>
                  setForm((s) => ({
                    ...s,
                    observacoes: observacoesInput,
                  }))
                }
                fullWidth
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <Tooltip
                        title={
                          !suporteVoz
                            ? "Ditado não suportado neste browser"
                            : reconhecendoVozObservacoes
                            ? "A gravar… clique para parar"
                            : campoVozAtivo
                            ? "Já existe outra gravação em curso"
                            : "Ditado por voz"
                        }
                      >
                        <span>
                          <IconButton
                            edge="end"
                            size="small"
                            onClick={() => {
                              if (reconhecendoVozObservacoes) {
                                pararVozObservacoes();
                                setCampoVozAtivo("");

                                setForm((s) => ({
                                  ...s,
                                  observacoes: observacoesInput,
                                }));
                              } else {
                                iniciarVozObservacoes();
                                setCampoVozAtivo("observacoes");
                              }
                            }}
                            disabled={botaoVozDesativado("observacoes")}
                            sx={{
                              color: reconhecendoVozObservacoes ? "error.main" : "action.active",
                            }}
                          >
                            <Icon fontSize="small">
                              {reconhecendoVozObservacoes ? "mic_off" : "mic"}
                            </Icon>
                          </IconButton>
                        </span>
                      </Tooltip>
                    </InputAdornment>
                  ),
                }}
                sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2, fontSize: 13 } }}
              />
            </MDBox>
          ) : (
            <MDBox sx={{ flex: 1, width: "100%", minWidth: 0 }}>
              <MDTypography variant="button" sx={{ fontSize: 12, opacity: 0.75 }}>
                Após gravar (para obter o ID), ficam disponíveis: Observações, Auxílios e
                Ocorrências.
              </MDTypography>
            </MDBox>
          )}
        </MDBox>

        {temId && (
          <MDBox>
            {/* AUXÍLIOS */}
            <MDBox mt={3}>
              <MDTypography variant="button" sx={{ fontSize: 13, fontWeight: 700 }}>
                Auxílio Armazém 1
              </MDTypography>

              <MDBox mt={1} display="flex" gap={2} flexWrap="wrap">
                {nullIfEmpty(form.motorista) && (
                  <MDBox sx={{ minWidth: 260 }}>
                    <MDTypography variant="button" sx={{ fontSize: 12, mb: 0.5 }}>
                      Distribuidor 1
                    </MDTypography>

                    <select
                      value={Number(form.auxilio_mot_arm1)}
                      onChange={(e) =>
                        setForm((s) => ({
                          ...s,
                          auxilio_mot_arm1: Number(e.target.value),
                        }))
                      }
                      disabled={!podeEditarAux}
                      style={{
                        width: "100%",
                        padding: "10px 12px",
                        borderRadius: 8,
                        border: "1px solid rgba(0,0,0,0.23)",
                        fontSize: 13,
                        background: "white",
                      }}
                    >
                      <option value={2}>INDEFINIDO</option>
                      <option value={1}>SIM</option>
                      <option value={0}>NÃO</option>
                    </select>
                  </MDBox>
                )}

                {nullIfEmpty(form.ajudante) && (
                  <MDBox sx={{ minWidth: 260 }}>
                    <MDTypography variant="button" sx={{ fontSize: 12, mb: 0.5 }}>
                      Distribuidor 2
                    </MDTypography>

                    <select
                      value={Number(form.auxilio_ajud_arm1)}
                      onChange={(e) =>
                        setForm((s) => ({
                          ...s,
                          auxilio_ajud_arm1: Number(e.target.value),
                        }))
                      }
                      disabled={!podeEditarAux}
                      style={{
                        width: "100%",
                        padding: "10px 12px",
                        borderRadius: 8,
                        border: "1px solid rgba(0,0,0,0.23)",
                        fontSize: 13,
                        background: "white",
                      }}
                    >
                      <option value={2}>INDEFINIDO</option>
                      <option value={1}>SIM</option>
                      <option value={0}>NÃO</option>
                    </select>
                  </MDBox>
                )}
              </MDBox>

              <MDBox mt={3}>
                <MDTypography variant="button" sx={{ fontSize: 13, fontWeight: 700 }}>
                  Auxílio Armazém 2
                </MDTypography>

                <MDBox mt={1} display="flex" gap={2} flexWrap="wrap">
                  {nullIfEmpty(form.motorista) && (
                    <MDBox sx={{ minWidth: 260 }}>
                      <MDTypography variant="button" sx={{ fontSize: 12, mb: 0.5 }}>
                        Distribuidor 1
                      </MDTypography>

                      <select
                        value={Number(form.auxilio_mot_arm2)}
                        onChange={(e) =>
                          setForm((s) => ({
                            ...s,
                            auxilio_mot_arm2: Number(e.target.value),
                          }))
                        }
                        disabled={!podeEditarAux}
                        style={{
                          width: "100%",
                          padding: "10px 12px",
                          borderRadius: 8,
                          border: "1px solid rgba(0,0,0,0.23)",
                          fontSize: 13,
                          background: "white",
                        }}
                      >
                        <option value={2}>INDEFINIDO</option>
                        <option value={1}>SIM</option>
                        <option value={0}>NÃO</option>
                      </select>
                    </MDBox>
                  )}

                  {nullIfEmpty(form.ajudante) && (
                    <MDBox sx={{ minWidth: 260 }}>
                      <MDTypography variant="button" sx={{ fontSize: 12, mb: 0.5 }}>
                        Distribuidor 2
                      </MDTypography>

                      <select
                        value={Number(form.auxilio_ajud_arm2)}
                        onChange={(e) =>
                          setForm((s) => ({
                            ...s,
                            auxilio_ajud_arm2: Number(e.target.value),
                          }))
                        }
                        disabled={!podeEditarAux}
                        style={{
                          width: "100%",
                          padding: "10px 12px",
                          borderRadius: 8,
                          border: "1px solid rgba(0,0,0,0.23)",
                          fontSize: 13,
                          background: "white",
                        }}
                      >
                        <option value={2}>INDEFINIDO</option>
                        <option value={1}>SIM</option>
                        <option value={0}>NÃO</option>
                      </select>
                    </MDBox>
                  )}
                </MDBox>
              </MDBox>

              {(nullIfEmpty(form.motorista) || nullIfEmpty(form.ajudante)) && !podeEditarAux && (
                <MDBox mt={1}>
                  <MDTypography variant="button" sx={{ fontSize: 12, opacity: 0.8 }}>
                    Nota: Auxílios só podem ser alterados por AdminLike, ou Armazém no dia / até 2
                    dias úteis anteriores.
                  </MDTypography>
                </MDBox>
              )}
            </MDBox>

            {/* OCORRÊNCIAS */}
            <MDBox mt={3}>
              <MDTypography variant="button" sx={{ fontSize: 13, fontWeight: 700 }}>
                Ocorrências
              </MDTypography>

              <MDBox mt={1} display="flex" flexDirection="column" gap={2}>
                <MDBox>
                  <MDTypography variant="button" sx={{ fontSize: 12, mb: 0.5 }}>
                    Diferença na Mercadoria
                  </MDTypography>

                  <select
                    value={normTri(form.dif_mercadoria)}
                    onChange={(e) => {
                      const novoValor = normTri(e.target.value);

                      if (novoValor !== 2) {
                        setDifMercadoriaDescInput("");
                      }

                      setForm((s) => ({
                        ...s,
                        dif_mercadoria: novoValor,
                        dif_mercadoria_desc: novoValor === 2 ? difMercadoriaDescInput : "",
                      }));
                    }}
                    disabled={!podeEditarCamposBase}
                    style={{
                      width: "100%",
                      padding: "10px 12px",
                      borderRadius: 8,
                      border: "1px solid rgba(0,0,0,0.23)",
                      fontSize: 13,
                      background: "white",
                    }}
                  >
                    <option value={0}>PENDENTE</option>
                    <option value={1}>CORRETA</option>
                    <option value={2}>INCORRETA</option>
                  </select>

                  {normTri(form.dif_mercadoria) === 2 && (
                    <TextField
                      size="small"
                      multiline
                      minRows={5}
                      maxRows={10}
                      value={difMercadoriaDescInput}
                      onChange={(e) => setDifMercadoriaDescInput(e.target.value)}
                      onBlur={() =>
                        setForm((s) => ({
                          ...s,
                          dif_mercadoria_desc: difMercadoriaDescInput,
                        }))
                      }
                      disabled={!podeEditarCamposBase}
                      fullWidth
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <Tooltip
                              title={
                                !suporteVoz
                                  ? "Ditado não suportado neste browser"
                                  : reconhecendoVozDifMercadoriaDesc
                                  ? "A gravar… clique para parar"
                                  : campoVozAtivo
                                  ? "Já existe outra gravação em curso"
                                  : "Ditado por voz"
                              }
                            >
                              <span>
                                <IconButton
                                  edge="end"
                                  size="small"
                                  onClick={() => {
                                    if (reconhecendoVozDifMercadoriaDesc) {
                                      pararVozDifMercadoriaDesc();
                                      setCampoVozAtivo("");

                                      setForm((s) => ({
                                        ...s,
                                        dif_mercadoria_desc: difMercadoriaDescInput,
                                      }));
                                    } else {
                                      iniciarVozDifMercadoriaDesc();
                                      setCampoVozAtivo("dif_mercadoria_desc");
                                    }
                                  }}
                                  disabled={botaoVozDesativado("dif_mercadoria_desc")}
                                  sx={{
                                    color: reconhecendoVozDifMercadoriaDesc
                                      ? "error.main"
                                      : "action.active",
                                  }}
                                >
                                  <Icon fontSize="small">
                                    {reconhecendoVozDifMercadoriaDesc ? "mic_off" : "mic"}
                                  </Icon>
                                </IconButton>
                              </span>
                            </Tooltip>
                          </InputAdornment>
                        ),
                      }}
                      sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2, fontSize: 13 } }}
                    />
                  )}
                </MDBox>

                <MDBox>
                  <MDTypography variant="button" sx={{ fontSize: 12, mb: 0.5 }}>
                    Quebras ou Produto Danificado
                  </MDTypography>

                  <select
                    value={normTri(form.quebras_danificado)}
                    onChange={(e) => {
                      const novoValor = normTri(e.target.value);

                      if (novoValor !== 2) {
                        setQuebrasDanificadoDescInput("");
                      }

                      setForm((s) => ({
                        ...s,
                        quebras_danificado: novoValor,
                        quebras_danificado_desc: novoValor === 2 ? quebrasDanificadoDescInput : "",
                      }));
                    }}
                    disabled={!podeEditarCamposBase}
                    style={{
                      width: "100%",
                      padding: "10px 12px",
                      borderRadius: 8,
                      border: "1px solid rgba(0,0,0,0.23)",
                      fontSize: 13,
                      background: "white",
                    }}
                  >
                    <option value={0}>PENDENTE</option>
                    <option value={1}>CORRETA</option>
                    <option value={2}>INCORRETA</option>
                  </select>

                  {normTri(form.quebras_danificado) === 2 && (
                    <TextField
                      size="small"
                      multiline
                      minRows={5}
                      maxRows={10}
                      value={quebrasDanificadoDescInput}
                      onChange={(e) => setQuebrasDanificadoDescInput(e.target.value)}
                      onBlur={() =>
                        setForm((s) => ({
                          ...s,
                          quebras_danificado_desc: quebrasDanificadoDescInput,
                        }))
                      }
                      disabled={!podeEditarCamposBase}
                      fullWidth
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <Tooltip
                              title={
                                !suporteVoz
                                  ? "Ditado não suportado neste browser"
                                  : reconhecendoVozQuebrasDanificadoDesc
                                  ? "A gravar… clique para parar"
                                  : campoVozAtivo
                                  ? "Já existe outra gravação em curso"
                                  : "Ditado por voz"
                              }
                            >
                              <span>
                                <IconButton
                                  edge="end"
                                  size="small"
                                  onClick={() => {
                                    if (reconhecendoVozQuebrasDanificadoDesc) {
                                      pararVozQuebrasDanificadoDesc();
                                      setCampoVozAtivo("");

                                      setForm((s) => ({
                                        ...s,
                                        quebras_danificado_desc: quebrasDanificadoDescInput,
                                      }));
                                    } else {
                                      iniciarVozQuebrasDanificadoDesc();
                                      setCampoVozAtivo("quebras_danificado_desc");
                                    }
                                  }}
                                  disabled={botaoVozDesativado("quebras_danificado_desc")}
                                  sx={{
                                    color: reconhecendoVozQuebrasDanificadoDesc
                                      ? "error.main"
                                      : "action.active",
                                  }}
                                >
                                  <Icon fontSize="small">
                                    {reconhecendoVozQuebrasDanificadoDesc ? "mic_off" : "mic"}
                                  </Icon>
                                </IconButton>
                              </span>
                            </Tooltip>
                          </InputAdornment>
                        ),
                      }}
                      sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2, fontSize: 13 } }}
                    />
                  )}
                </MDBox>

                <MDBox>
                  <MDTypography variant="button" sx={{ fontSize: 12, mb: 0.5 }}>
                    Diferença no Vasilhame
                  </MDTypography>

                  <select
                    value={normTri(form.dif_vasilhame)}
                    onChange={(e) => {
                      const novoValor = normTri(e.target.value);

                      if (novoValor !== 2) {
                        setDifVasilhameDescInput("");
                      }

                      setForm((s) => ({
                        ...s,
                        dif_vasilhame: novoValor,
                        dif_vasilhame_desc: novoValor === 2 ? difVasilhameDescInput : "",
                      }));
                    }}
                    disabled={!podeEditarCamposBase}
                    style={{
                      width: "100%",
                      padding: "10px 12px",
                      borderRadius: 8,
                      border: "1px solid rgba(0,0,0,0.23)",
                      fontSize: 13,
                      background: "white",
                    }}
                  >
                    <option value={0}>PENDENTE</option>
                    <option value={1}>CORRETA</option>
                    <option value={2}>INCORRETA</option>
                  </select>

                  {normTri(form.dif_vasilhame) === 2 && (
                    <TextField
                      size="small"
                      multiline
                      minRows={5}
                      maxRows={10}
                      value={difVasilhameDescInput}
                      onChange={(e) => setDifVasilhameDescInput(e.target.value)}
                      onBlur={() =>
                        setForm((s) => ({
                          ...s,
                          dif_vasilhame_desc: difVasilhameDescInput,
                        }))
                      }
                      disabled={!podeEditarCamposBase}
                      fullWidth
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <Tooltip
                              title={
                                !suporteVoz
                                  ? "Ditado não suportado neste browser"
                                  : reconhecendoVozDifVasilhameDesc
                                  ? "A gravar… clique para parar"
                                  : campoVozAtivo
                                  ? "Já existe outra gravação em curso"
                                  : "Ditado por voz"
                              }
                            >
                              <span>
                                <IconButton
                                  edge="end"
                                  size="small"
                                  onClick={() => {
                                    if (reconhecendoVozDifVasilhameDesc) {
                                      pararVozDifVasilhameDesc();
                                      setCampoVozAtivo("");

                                      setForm((s) => ({
                                        ...s,
                                        dif_vasilhame_desc: difVasilhameDescInput,
                                      }));
                                    } else {
                                      iniciarVozDifVasilhameDesc();
                                      setCampoVozAtivo("dif_vasilhame_desc");
                                    }
                                  }}
                                  disabled={botaoVozDesativado("dif_vasilhame_desc")}
                                  sx={{
                                    color: reconhecendoVozDifVasilhameDesc
                                      ? "error.main"
                                      : "action.active",
                                  }}
                                >
                                  <Icon fontSize="small">
                                    {reconhecendoVozDifVasilhameDesc ? "mic_off" : "mic"}
                                  </Icon>
                                </IconButton>
                              </span>
                            </Tooltip>
                          </InputAdornment>
                        ),
                      }}
                      sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2, fontSize: 13 } }}
                    />
                  )}
                </MDBox>
              </MDBox>

              <MDBox mt={4} display="flex" flexDirection="column" gap={2}>
                <MDTypography variant="button" sx={{ fontSize: 13, fontWeight: 700 }}>
                  Boa imagem da empresa
                </MDTypography>

                <MDBox>
                  <MDTypography variant="button" sx={{ fontSize: 12, mb: 0.5 }}>
                    Limpeza da Viatura
                  </MDTypography>

                  <select
                    value={Number(form.limpeza_viatura)}
                    onChange={(e) =>
                      setForm((s) => ({
                        ...s,
                        limpeza_viatura: Number(e.target.value),
                      }))
                    }
                    disabled={!podeEditarCamposBase}
                    style={{
                      width: "100%",
                      padding: "10px 12px",
                      borderRadius: 8,
                      border: "1px solid rgba(0,0,0,0.23)",
                      fontSize: 13,
                      background: "white",
                    }}
                  >
                    <option value={2}>INDEFINIDO</option>
                    <option value={1}>SIM</option>
                    <option value={0}>NÃO</option>
                  </select>
                </MDBox>
              </MDBox>
            </MDBox>
          </MDBox>
        )}
      </DialogContent>

      <DialogActions
        sx={{
          flexWrap: "wrap",
          gap: 1,
          justifyContent: { xs: "flex-start", sm: "flex-end" },
        }}
      >
        <MDButton color="light" onClick={onClose}>
          Sair
        </MDButton>

        {temId && (
          <MDButton
            color="dark"
            variant="outlined"
            startIcon={<AttachFileIcon />}
            onClick={() => setOpenFicheiros(true)}
          >
            Anexos
          </MDButton>
        )}

        {temId && form.estado === 0 && (
          <MDButton
            color="success"
            onClick={() => {
              setForm((s) => ({
                ...s,
                observacoes: observacoesInput,
                conf_mapa_carga_desc: confMapaCargaDescInput,
                dif_mercadoria_desc: difMercadoriaDescInput,
                quebras_danificado_desc: quebrasDanificadoDescInput,
                dif_vasilhame_desc: difVasilhameDescInput,
              }));

              setTimeout(() => {
                handleEncerrar();
              }, 0);
            }}
            disabled={temPendentesOcorrencias}
          >
            Encerrar
          </MDButton>
        )}

        <MDButton
          color="info"
          onClick={() => {
            setForm((s) => ({
              ...s,
              observacoes: observacoesInput,
              conf_mapa_carga_desc: confMapaCargaDescInput,
              dif_mercadoria_desc: difMercadoriaDescInput,
              quebras_danificado_desc: quebrasDanificadoDescInput,
              dif_vasilhame_desc: difVasilhameDescInput,
            }));

            setTimeout(() => {
              handleSave();
            }, 0);
          }}
          disabled={normTri(form.conf_mapa_carga) === 0 || refTransporteDuplicada}
        >
          Gravar
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}
